<template>
    <button :type="type || 'button'" :disabled="disabled">
        <span v-if="loading" class="spinner-border spinner-border-sm mr-2"
              aria-hidden="true">
        </span>
        <slot>{{ text }}</slot>
    </button>
</template>

<script>
export default {
    props: ['loading', 'text', 'disabled', 'type'],
}
</script>
